import { flow } from 'lodash';

import { NAME } from './pdv.constant';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStateKey);
